import { atom, useAtom } from "jotai";

export const optionIsPostOnlyAtom = atom<boolean>(false);

export const useOptionIsPostOnly = () => {
  const [optionIsPostOnly, setOptionIsPostOnly] = useAtom(optionIsPostOnlyAtom);

  return {
    optionIsPostOnly,
    setOptionIsPostOnly,
  };
};
